// Top-of-page strip: title, optional subtitle, optional actions slot
// (typically a "Create X" button on list pages).

import type { ReactNode } from "react";

import { Breadcrumbs } from "./Breadcrumbs";

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  showBreadcrumbs?: boolean;
}

export function PageHeader({
  title,
  subtitle,
  actions,
  showBreadcrumbs = true,
}: PageHeaderProps) {
  return (
    <header style={{ marginBottom: 20 }}>
      {showBreadcrumbs && <Breadcrumbs />}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: "1.4rem", letterSpacing: "-0.01em" }}>
            {title}
          </h2>
          {subtitle && (
            <p style={{ margin: "4px 0 0", color: "var(--text-dim)", fontSize: "0.85rem" }}>
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div style={{ display: "flex", gap: 8 }}>{actions}</div>}
      </div>
    </header>
  );
}
